import type { Enums } from "@msuite/utils/types";
import type { PropsWithChildren } from "react";
import { Icon, type IconName } from "../icons";
import { Tag, type TagProps } from "./tag";

/** Props Interface */
interface IconTagProps extends PropsWithChildren, Omit<TagProps, "color"> {
	iconName: IconName;
	color?: Enums<"color">;
}

export function IconTag({ children, iconName, color = "gray", variant = "plain" }: IconTagProps) {
	return (
		<Tag
			className="h-stack"
			color={color}
			withStatusIndicator={false}
			variant={variant}
		>
			<div className="h-stack items-center gap-2">
				<Icon
					name={iconName}
					stroke={`var(--color-${color}-500`}
				/>
				<p>{children}</p>
			</div>
		</Tag>
	);
}
